module.exports = __webpack_public_path__ + "static/img/9.6ac330d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/9.png
// module id = FlJP
// module chunks = 0